import { useResetPass } from "@/features/user/hooks/use-reset-pass";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";

export const ResetPass = () => {
  const {
    email,
    emailError,
    isActiveSendMailButton,
    onChangeMailAddress,
    changeSendMailButtonState,
    onClickSendMail,
  } = useResetPass();

  useEffect(() => {
    changeSendMailButtonState();
  }, [email]);

  const navigate = useNavigate();

  // メールアドレスフォームに付与するID
  const mailAddressFormId = "rePassMail";
  // メール送信ボタンに付与するID
  const sendMailButtonId = "btnRePass";

  return (
    <>
      <LoginHeader content="パスワードの再設定" />
      <main>
        <section id="rePass">
          <nav className="step">
            <ol>
              <li className="active">再設定メールを送信</li>
              <li>新パスワードの設定</li>
              <li>再設定完了</li>
            </ol>
          </nav>
          <p>パスワード再設定メールを送信します</p>
          <ul className="form">
            <li>
              <MailAddressForm
                onChange={onChangeMailAddress}
                errorMessage={emailError}
                id={mailAddressFormId}
                initialValue={email}
                title="メールアドレス"
              />
            </li>
          </ul>
          <nav className="btns">
            <span style={{ marginRight: "0.3rem"}}>
              <BaseRoundButton
                buttonText="キャンセル"
                onClick={() => 
                  navigate(EndpointPathNames.LOGIN)}
                className="btn-base"
                isActive={true}
              />
            </span>
            <BaseRoundButton
              id={sendMailButtonId}
              buttonText="メールを送信"
              onClick={() => onClickSendMail()}
              isActive={isActiveSendMailButton}
              className="nav-main"
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};